import React from 'react';
import Button from '../UI/Button/Button';
import './SearchControls.scss';

const SearchControls = ({ prevList, nextList, disabledPrev, disabledNext }) => {
  return (
    <div className="search-controls">
      <Button
        buttonType={'search-controls-btn search-controls-btn__prev'}
        clicked={prevList}
        disabled={disabledPrev}>
        <span
          className={
            'search-controls-btn__arrow search-controls-btn__arrow-left'
          }>
          Previous
        </span>
      </Button>
      <Button
        buttonType={'search-controls-btn search-controls-btn__next'}
        clicked={nextList}
        disabled={disabledNext}>
        <span
          className={
            'search-controls-btn__arrow search-controls-btn__arrow-right'
          }>
          Next
        </span>
      </Button>
    </div>
  );
};

export default SearchControls;
